import isObject from './isObject.js';

/**
 * Logger class
 * @class WatchingYou
 */
export default class WatchingYou {

	/**
	 * Init the class
	 * @public
	 * @memberof WatchingYou
	 */
	constructor() {
		this.loggers = [];
	}

	/**
	 * Make the actual log, call setup loggers
	 * @param {string} level log,info,warn,error,debug
	 * @param {Array} data
	 * @private
	 * @memberof WatchingYou
	 */
	_log(level, data = []) {
		if (['log', 'info', 'warn', 'error', 'debug', 'count', 'gauge', 'timing'].includes(level) && Array.isArray(data)) {
			const date = new Date();
			this.loggers.forEach((logger) => logger.log(level, date, data));
		} else {
			throw new Error('Invalid method arguments to WatchingYou._log');
		}
	}

	/**
	 * Add logger to be used
	 * @param {object} logger Instance of logger
	 * @public
	 * @memberof WatchingYou
	 */
	addLogger(logger) {
		if (isObject(logger) && typeof logger.log === 'function') {
			this.loggers.push(logger);
		} else {
			throw new Error('Invalid method arguments to WatchingYou.addLogger');
		}
	}

	/**
	 * Basic log
	 * @public
	 * @memberof WatchingYou
	 */
	log() {
		this._log('log', Array.from(arguments));
	}

	/**
	 * Info log
	 * @public
	 * @memberof WatchingYou
	 */
	info() {
		this._log('info', Array.from(arguments));
	}

	/**
	 * Warning log
	 * @public
	 * @memberof WatchingYou
	 */
	warn() {
		this._log('warn', Array.from(arguments));
	}

	/**
	 * Error log
	 * @public
	 * @memberof WatchingYou
	 */
	error() {
		this._log('error', Array.from(arguments));
	}

	/**
	 * Debug log
	 * @public
	 * @memberof WatchingYou
	 */
	debug() {
		this._log('debug', Array.from(arguments));
	}

	/**
	 * Count log
	 * @public
	 * @memberof WatchingYou
	 */
	count() {
		this._log('count', Array.from(arguments));
	}

	/**
	 * Gauge log (non-standard)
	 * @public
	 * @memberof WatchingYou
	 */
	gauge() {
		this._log('gauge', Array.from(arguments));
	}

	/**
	 * Timing log (non-standard)
	 * @public
	 * @memberof WatchingYou
	 */
	timing() {
		this._log('timing', Array.from(arguments));
	}

}
